import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import { actions as assetActions } from "../actions/asset";
import { actions as contentActions } from "../actions/content";
import { actions as appActions } from "../actions/app";
import { actions as axisDeficientAssetUrlActions } from "../actions/axisDeficientAssetUrl";
import { actions as axisOrderActions } from "../actions/axisOrder";
import { actions as snackbarActions } from "../actions/snackbar";
import { actions as savedItemsActions } from "../actions/savedItems";
import { sendMosMessageToContainer } from "../api/container";
import AssetEditor from "../components/Editor/";
import SlidingOverlay from "../components/SlidingOverlay";
import SidebarState from "../constants/sidebarState";
import Footer from "../components/Footer";
import EditorFooterContent from "../components/Editor/EditorFooterContent";
import ConfirmCloseDialog from "../components/OrderForm/ConfirmCloseDialog";
import PublishingDialog from "../components/PublishingDialog";
import RenderMediaDialog from "../components/RenderMediaDialog";
import ContentSelectionLayout from "./ContentSelectionLayout";
import OrderGraphicLayout from "./OrderGraphicLayout";
import BuildGraphicLayout from "./BuildGraphicLayout";
import LuciPropTypes from "../propTypes/";
import {
  Container,
  StickyHeader,
  MainContent
} from "../styled-components/Layout";
import { Select, SelectLabel, CloseButton } from "../styled-components/";
import { makeGetReplaceable } from "../selectors/asset";
import AssetType from "../constants/assetTypes";
import DataEngine from "../../public/js/de";
import { Requestor, Replier } from "../../public/js/de.msg.request-reply";
import AppMode from "../constants/appMode";
import Settings from "../settings";
import localize from "../util/localizeUtils";
import StringUtils from "../util/stringUtils";
import TemplateSelectionLayout from "./TemplateSelectionLayout";
import SavedItemsDialog from "../components/SavedItems/Dialog";
import EditorSideBarContent from "../components/Editor/EditorSideBarContent";
import DarkLightModeButton from "../components/DarkLightModeButton";
import PrimeStyleSelect from "../components/Editor/PrimeStyleSelect";

const Mousetrap = window.Mousetrap;
const debug = process.env.NODE_ENV === "development";

const Header = styled(StickyHeader)`
  background-color: ${props => props.theme.editor.header};
  display: flex;
  flex-wrap: wrap;
  padding-left: 0.5rem;
  width: 100%;
  height: 1.5rem;
`;

const HeaderText = styled.div`
  align-self: center;
  flex: 1;
  min-width: 30%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const TransitionList = styled.div`
  align-self: center;
`;

const MainContentDiv = styled(MainContent)`
  flex-direction: row;
  display: flex;
  height: 100%;
`;

const CloseEdit = styled(CloseButton)`
  font-size: 12px;
  padding: 0 1rem;
`;

const DarkModeIcon = styled.div`
  font-size: 24px;
  margin-right: 0.25rem;
  display: flex;
`;

class EditorLayout extends React.Component {
  constructor(props) {
    super(props);

    let assetId = null;
    if (props.assetId) {
      assetId = props.assetId;
    } else if (props.params && props.params.id) {
      assetId = props.params.id;
    }

    this.state = {
      contentSelectionDialogVisible: false,
      orderGraphicDialogVisible: false,
      buildGraphicDialogVisible: false,
      confirmCancelOrderDialogVisible: false,
      publishingDialogVisible: false,
      renderMediaDialogVisible: false,
      showChangeTemplateDialog: false,
      changeTemplateDialogVisible: false,
      savedItemDialogVisible: false,
      assetId
    };

    if (!props.title && props.params && props.params.id) {
      props.loadAsset(props.params.id);
    }

    if (props.sessionId) {
      this.setUpMessaging(props.sessionId);
    }
  }
  UNSAFE_componentWillMount() {
    this.props.changeFooterHeight("5rem");
    this.props.changeSidebarState(SidebarState.NONE);
    if (this.props.channelList.length === 0) {
      this.props.loadChannelList();
    }

    if (
      this.props.showAutomationTransitions &&
      this.props.automationTransitionList.length === 0
    ) {
      this.props.loadAutomationTransitionList();
    }
  }

  componentDidMount() {
    if (this.props.isMosObject && this.props.containerType === "ACTIVEX") {
      sendMosMessageToContainer(`edit:${this.props.mosObjectId}`);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.axisDeficientAssetUrl &&
      nextProps.axisDeficientAssetUrl !== this.props.axisDeficientAssetUrl
    ) {
      window.open(
        nextProps.axisDeficientAssetUrl,
        "_blank",
        "fullscreen=1,location=0,titlebar=0,menubar=0"
      );
      axisDeficientAssetUrlActions.clearAxisDeficientAssetUrl();
    }

    // if edit is already open and another is selected
    if (
      nextProps.mosObjectId &&
      nextProps.mosObjectId !== this.props.mosObjectId &&
      this.props.containerType === "ACTIVEX"
    ) {
      sendMosMessageToContainer(`edit:${nextProps.mosObjectId}`);
    }

    if (this.props.assetId !== nextProps.assetId) {
      this.setState({ assetId: nextProps.assetId });
    }
  }

  componentWillUnmount() {
    if (this.de) {
      this.de.close();
    }
    this.props.clearAsset();
  }

  onCreateSavedItem = preserveMosId => {
    this.props.createSavedItem(this.props.mosObjectId, preserveMosId);
    this.closeSavedItemDialog();
  };

  getOrderDialogTitle() {
    return this.props.assetType.toLowerCase() === "image"
      ? localize("orderImageOverlayTitle")
      : localize("orderMovieOverlayTitle");
  }

  setUpMessaging = sessionId => {
    const bucket = "luci.messaging";
    this.de =
      window.location.protocol === "https:"
        ? new DataEngine({ path: "dataengine/", bucket })
        : new DataEngine({
            host: window.location.hostname,
            bucket,
            port: 4300
          });
    this.de.connection.onConnect = () => {
      this.requestor = new Requestor(
        this.de,
        `luci.messaging.${sessionId}-clipper`,
        30000
      );
      this.replier = new Replier(this.de, `luci.messaging.${sessionId}-luci`);
      console.log(
        `Data engine connected to ${window.location.hostname}:4300, 'luci.messaging.${sessionId}'`
      );
    };
  };

  openAssetBrowserDialog = (
    assetType,
    assetCategory,
    restrictAssetCategory
  ) => {
    Mousetrap.bindGlobal("esc", this.closeAssetBrowserDialog);
    if (assetType) {
      this.props.loadContent(assetType, assetCategory, restrictAssetCategory);
      this.props.getFilterOptions(this.props.userId, assetType);
    }
    this.setState({
      contentSelectionDialogVisible: true
    });
  };

  closeAssetBrowserDialog = () => {
    Mousetrap.unbind("esc");
    this.setState({
      contentSelectionDialogVisible: false
    });
  };

  closeChangeTemplateDialog = () => {
    this.setState({
      changeTemplateDialogVisible: false
    });
  };

  closeSavedItemDialog = () => {
    this.setState({
      savedItemDialogVisible: false
    });
  };

  openOrderGraphicDialog = () => {
    Mousetrap.bindGlobal("esc", this.closeOrderGraphicDialog);
    this.props.startOrder(this.props.selectedReplaceable);
    this.setState({
      contentSelectionDialogVisible: false,
      orderGraphicDialogVisible: true
    });
  };

  closeOrderGraphicDialog = () => {
    Mousetrap.bindGlobal("esc", this.closeAssetBrowserDialog);
    if (this.props.orderHasChanges) {
      this.setState({ confirmCancelOrderDialogVisible: true });
    } else {
      this.setState({
        orderGraphicDialogVisible: false
      });
    }
  };

  openSavedItemDialog = () => {
    this.setState({ savedItemDialogVisible: true });
  };

  handleClickBuildGraphic = () => {
    const { properties } = this.props.selectedReplaceable;

    const isAxisReplaceable =
      properties.axisTemplate ||
      properties.axisStyle ||
      properties["axis template id"] ||
      properties.axisService === "Charts";
    const isVidigoTemplate = this.props.templateType === AssetType.AUTOMATION;

    if (isAxisReplaceable) {
      return this.openAxisWindow();
    } else if (isVidigoTemplate && Settings.enableClipper) {
      return this.openClipper();
    }

    return this.openBuildGraphicDialog();
  };

  openClipper = () => {
    const clipperUrl =
      this.props.containerType === "ACTIVEX"
        ? `clipper://launch/${this.props.user}/${this.props.sessionId}`
        : `${debug ? "http://localhost:3000/" : Settings.serverPath}#/clipper/${
            this.props.user
          }/${this.props.sessionId}`;

    if (this.props.containerType === "ACTIVEX") {
      sendMosMessageToContainer(clipperUrl);
    } else {
      window.open(
        clipperUrl,
        "_blank",
        `height=${window.screen.availHeight - 60},width=${
          window.screen.availWidth
        },titlebar=no,location=no,status=no,toolbar=no,left=0,top=0`
      );
    }
    setTimeout(
      () =>
        this.requestor
          .request({
            type: "INITIALIZE_CLIPPER"
          })
          .then(reply => {
            if (reply.type === "CLIPPER_INITIALIZED") {
              this.props.setAppMode(AppMode.CLIPPER_ACTIVE);
            }
            return Promise.resolve();
          })
          .catch(err => {
            console.log("Sending message to data engine failed.");
            console.log(err);
          }),
      3000
    );
    this.replier.onMessage = (message, callback) => {
      const messageData = message.data || message;
      switch (messageData.type) {
        case "CLIPPER_CLOSED":
          this.props.setAppMode(AppMode.EDIT);
          if (messageData.redirect) {
            hashHistory.push("/assets");
          }
          break;
        case "MOVIE_SELECTED":
          this.props.updateSelectedReplaceable(
            messageData.asset.id,
            messageData.asset.thumbnailUrl,
            messageData.asset.provider
          );
          break;
        case "INSERT_FROM_CLIPPER":
          this.props.insertFromClipper(messageData.mosObjects);
          callback(null, { type: "INSERT_CONFIRMED" });
          break;
        default:
          break;
      }
    };
  };

  openBuildGraphicDialog = () => {
    Mousetrap.bindGlobal("esc", this.closeBuildGraphicDialog);
    this.setState({
      buildGraphicDialogVisible: true
    });
  };

  openAxisWindow = () => {
    // create deficient asset, on success, open new window with url from response
    this.props.loadAxisDeficientAssetUrl(this.props.selectedReplaceable);
  };

  closeBuildGraphicDialog = () => {
    Mousetrap.bindGlobal("esc", this.closeAssetBrowserDialog);
    this.setState({
      buildGraphicDialogVisible: false
    });
    this.props.getContent(this.props.assetType, "localcontent");
  };

  handleExitClick = () => {
    if (this.props.containerType === "ACTIVEX") {
      sendMosMessageToContainer("closeEdit");
    }
    this.props.setAppMode(AppMode.NORMAL);
    if (!this.props.overlay) {
      hashHistory.push("/assets");
    }
  };

  automationTransitionChanged = event => {
    this.props.updateTemplateProperty(
      "automation transition",
      event.target.value
    );
  };

  showPublishingDialog = () => {
    this.setState({ publishingDialogVisible: true });
  };

  showRenderMediaDialog = () => {
    this.setState({ renderMediaDialogVisible: true });
  };

  showChangeTemplateDialog = () => {
    this.setState({ changeTemplateDialogVisible: true });
  };

  renderAutomationTransitionList = () => {
    if (this.props.showAutomationTransitions) {
      return (
        <TransitionList>
          <SelectLabel htmlFor="transition-select">
            {localize("automationTransitionsLabel")}
          </SelectLabel>
          <Select
            height="1.25rem"
            id="transition-select"
            labelPadding="9.6rem"
            value={this.props.selectedAutomationTransition}
            onChange={this.automationTransitionChanged}
          >
            {this.props.automationTransitionList != null &&
            this.props.automationTransitionList.length > 0
              ? this.props.automationTransitionList.map(transition => (
                  <option key={transition.id} value={transition.value}>
                    {transition.value}
                  </option>
                ))
              : null}
          </Select>
        </TransitionList>
      );
    }

    return null;
  };

  renderPrimeStylesList = () => {
    if (this.props.fileType === "prime-graphics") {
      return (
        <PrimeStyleSelect
          primeStyles={this.props.primeStylesList}
          selectedStyle={this.props.primeStyle}
          onChange={this.props.changePrimeStyle}
        />
      );
    }
    return null;
  };

  render() {
    const {
      assetType,
      title,
      isMosObject,
      editing,
      mosObjectId,
      overlay,
      onComplete
    } = this.props;
    const {
      contentSelectionDialogVisible,
      orderGraphicDialogVisible,
      buildGraphicDialogVisible,
      publishingDialogVisible,
      renderMediaDialogVisible,
      changeTemplateDialogVisible,
      savedItemDialogVisible,
      assetId
    } = this.state;

    return (
      <Container>
        <Header editMode={isMosObject}>
          <HeaderText title={title}>{`${
            isMosObject ? localize("editModeTitle") + " - " : ""
          }${title}`}</HeaderText>
          {this.renderPrimeStylesList()}
          {this.renderAutomationTransitionList()}
          <DarkModeIcon>
            <DarkLightModeButton />
          </DarkModeIcon>
          <CloseEdit onClick={this.handleExitClick}>
            {localize("closeEditorButton")}
          </CloseEdit>
        </Header>
        <SlidingOverlay
          visible={contentSelectionDialogVisible}
          title={StringUtils.capitalize(assetType)}
          onClose={this.closeAssetBrowserDialog}
        >
          <ContentSelectionLayout
            visible={contentSelectionDialogVisible}
            openOrderGraphicDialog={this.openOrderGraphicDialog}
            openBuildGraphicDialog={this.handleClickBuildGraphic}
            onConfirmAssetSelected={this.closeAssetBrowserDialog}
          />
        </SlidingOverlay>
        <SlidingOverlay
          visible={changeTemplateDialogVisible}
          title={localize("templatesOverlayTitle")}
          onClose={this.closeChangeTemplateDialog}
        >
          <TemplateSelectionLayout
            changeTemplate
            onConfirmAssetSelected={this.closeChangeTemplateDialog}
            visible={changeTemplateDialogVisible}
          />
        </SlidingOverlay>
        <SlidingOverlay
          onClose={this.closeOrderGraphicDialog}
          title={this.getOrderDialogTitle()}
          visible={orderGraphicDialogVisible}
        >
          <OrderGraphicLayout />
        </SlidingOverlay>
        <SlidingOverlay
          title={localize("compositorOverlayTitle")}
          onClose={this.closeBuildGraphicDialog}
          visible={buildGraphicDialogVisible}
        >
          <BuildGraphicLayout
            onAssembleComplete={this.closeBuildGraphicDialog}
            visible={buildGraphicDialogVisible}
          />
        </SlidingOverlay>
        <ConfirmCloseDialog
          isOpen={this.state.confirmCancelOrderDialogVisible}
          onCancelClick={() =>
            this.setState({ confirmCancelOrderDialogVisible: false })
          }
          onOkClick={() =>
            this.setState({
              orderGraphicDialogVisible: false,
              confirmCancelOrderDialogVisible: false
            })
          }
        />
        <PublishingDialog
          isClipperAsset={false}
          isOpen={publishingDialogVisible}
          closeDialog={() => this.setState({ publishingDialogVisible: false })}
        />
        <RenderMediaDialog
          isOpen={renderMediaDialogVisible}
          closeDialog={() => this.setState({ renderMediaDialogVisible: false })}
        />
        <SavedItemsDialog
          isOpen={savedItemDialogVisible}
          mosObjectId={mosObjectId}
          showSaveAs={editing}
          onSubmit={preserveMosId => this.onCreateSavedItem(preserveMosId)}
          closeDialog={() => this.closeSavedItemDialog()}
        />
        <MainContentDiv>
          <AssetEditor openDialog={this.openAssetBrowserDialog} />
          <EditorSideBarContent
            showPublishingDialog={this.showPublishingDialog}
            showRenderMediaDialog={this.showRenderMediaDialog}
            showChangeTemplateDialog={this.showChangeTemplateDialog}
            showSaveItemDialog={this.openSavedItemDialog}
            sendFromCamio={overlay}
            onComplete={onComplete}
            includeRunningOrderInfo={this.context.router.isActive(
              "/runningorders/"
            )}
          />
        </MainContentDiv>
        <Footer>
          <EditorFooterContent />
        </Footer>
      </Container>
    );
  }
}

EditorLayout.contextTypes = {
  router: PropTypes.object
};

EditorLayout.defaultProps = {
  channelList: [],
  automationTransitionList: [],
  selectedAutomationTransition: "",
  showAutomationTransitions: false,
  axisDeficientAssetUrl: "",
  sessionId: null,
  mosObjectId: null,
  title: null,
  user: null,
  userId: null,
  insertedObjId: null,
  overlay: false,
  assetId: null,
  onComplete: null,
  primeStyle: null,
  fileType: null
};

EditorLayout.propTypes = {
  user: PropTypes.string,
  userId: PropTypes.number,
  channelList: LuciPropTypes.ChannelList,
  automationTransitionList: LuciPropTypes.AutomationTransitionList,
  selectedAutomationTransition: PropTypes.string,
  showAutomationTransitions: PropTypes.bool,
  loadChannelList: PropTypes.func.isRequired,
  loadAutomationTransitionList: PropTypes.func.isRequired,
  loadContent: PropTypes.func.isRequired,
  getContent: PropTypes.func.isRequired,
  changeSidebarState: PropTypes.func.isRequired,
  loadAxisDeficientAssetUrl: PropTypes.func.isRequired,
  startOrder: PropTypes.func.isRequired,
  sidebar: PropTypes.string.isRequired,
  assetType: PropTypes.string.isRequired,
  axisDeficientAssetUrl: PropTypes.string,
  selectedReplaceable: LuciPropTypes.Replaceable.isRequired,
  orderHasChanges: PropTypes.bool.isRequired,
  templateType: PropTypes.string.isRequired,
  setAppMode: PropTypes.func.isRequired,
  sessionId: PropTypes.string,
  containerType: PropTypes.string.isRequired,
  isMosObject: PropTypes.bool.isRequired,
  mosObjectId: PropTypes.string,
  title: PropTypes.string,
  updateSelectedReplaceable: PropTypes.func.isRequired,
  insertFromClipper: PropTypes.func.isRequired,
  getFilterOptions: PropTypes.func.isRequired,
  updateTemplateProperty: PropTypes.func.isRequired,
  inserting: PropTypes.bool.isRequired,
  insertFailed: PropTypes.bool.isRequired,
  showSnack: PropTypes.func.isRequired,
  insertedObjId: PropTypes.string,
  footerHeight: PropTypes.string.isRequired,
  changeFooterHeight: PropTypes.func.isRequired,
  clearAsset: PropTypes.func.isRequired,
  loadAsset: PropTypes.func.isRequired,
  createSavedItem: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired,
  overlay: PropTypes.bool,
  appMode: PropTypes.string.isRequired,
  assetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onComplete: PropTypes.func,
  primeStyle: PropTypes.string,
  primeStylesList: PropTypes.arrayOf(LuciPropTypes.PrimeStyle).isRequired,
  changePrimeStyle: PropTypes.func.isRequired,
  fileType: PropTypes.string
};

const makeMapStateToProps = () => {
  const getReplaceable = makeGetReplaceable();

  const mapStateToProps = state => ({
    user: state.auth.user.username,
    userId: state.auth.user.userId,
    channelList: state.asset.channelList,
    automationTransitionList: state.asset.automationTransitionList,
    selectedAutomationTransition:
      state.asset.templateDefinition.properties &&
      state.asset.templateDefinition.properties["automation transition"]
        ? state.asset.templateDefinition.properties["automation transition"]
        : "",
    showAutomationTransitions: state.app.config.luci
      ? state.app.config.luci.mozartTransitions
      : false,
    sidebar: state.app.sidebar,
    assetType: state.content.assetType,
    axisDeficientAssetUrl: state.axisDeficientAssetUrl.url,
    selectedReplaceable: getReplaceable(
      state,
      state.asset.selectedReplaceableId
    ),
    orderHasChanges: state.axisOrder.hasChanges,
    templateType: state.assets.assetType,
    sessionId: state.auth.user.sessionId,
    containerType: state.app.containerType,
    isMosObject: state.asset.isMosObject,
    mosObjectId: state.asset.isMosObject ? state.asset.asset.mosObjectId : null,
    title: state.asset.isMosObject
      ? state.asset.asset.abstract || state.asset.asset.mosObjectId
      : state.asset.asset.title,
    inserting: state.asset.inserting,
    insertFailed: state.asset.insertFailed || false,
    insertedObjId: state.asset.insertedObjId,
    footerHeight: state.app.footerHeight,
    editing: state.asset.editing,
    appMode: state.app.appMode,
    primeStyle: state.asset.primeStyle,
    primeStylesList: state.asset.primeStylesList,
    fileType: state.asset.asset ? state.asset.asset.fileType : null
  });
  return mapStateToProps;
};

const mapActionCreators = {
  loadChannelList: assetActions.loadChannelList,
  loadAutomationTransitionList: assetActions.loadAutomationTransitionList,
  loadContent: contentActions.loadContent,
  getContent: contentActions.getContent,
  changeSidebarState: appActions.changeSidebarState,
  loadAxisDeficientAssetUrl:
    axisDeficientAssetUrlActions.createAxisDeficientAsset,
  startOrder: axisOrderActions.startOrder,
  setAppMode: appActions.setAppMode,
  updateSelectedReplaceable: assetActions.updateSelectedReplaceable,
  getFilterOptions: contentActions.getFilterOptions,
  updateTemplateProperty: assetActions.updateTemplateProperty,
  insertFromClipper: assetActions.insertFromClipper,
  showSnack: snackbarActions.showSnack,
  changeFooterHeight: appActions.changeFooterHeight,
  clearAsset: assetActions.clearAsset,
  loadAsset: assetActions.loadAsset,
  createSavedItem: savedItemsActions.createSavedItem,
  changePrimeStyle: assetActions.changePrimeStyle
};

export default connect(makeMapStateToProps, mapActionCreators)(EditorLayout);



// WEBPACK FOOTER //
// ./app/layouts/EditorLayout.js